<div class="main-container">
  <mat-card appearance="outlined">
    <mat-card-title>Account Information</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Username</strong></th>
          <td>{{profileModel.username}}</td>
        </tr>
        <tr>
          <th><strong>First Name</strong></th>
          <td>{{profileModel.firstName}}</td>
        </tr>
        <tr>
          <th><strong>Last Name</strong></th>
          <td>{{profileModel.lastName}}</td>
        </tr>
        <tr>
          <th><strong>Email</strong></th>
          <td>{{profileModel.email}}</td>
        </tr>
        <tr>
          <th><strong>Phone Number</strong></th>
          <td>{{profileModel.phoneNumber | phoneNumber}}</td>
        </tr>
        <tr>
          <th><strong>Extension</strong></th>
          <td>{{profileModel.extension}}</td>
        </tr>
        <tr>
          <th><strong>Created On</strong></th>
          <td>{{profileModel.createdOn | dateTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        <tr>
          <th><strong>Last Updated On</strong></th>
          <td>{{profileModel.updatedOn | dateTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
    <mat-card-actions>
      <a routerLink="{{editProfileUrl}}" mat-raised-button color="primary" matTooltip="Edit Profile"
         *ngIf="hasEditAccess">Edit</a>
    </mat-card-actions>
  </mat-card>
</div>

<div class="main-container">
  <mat-card appearance="outlined">
    <mat-card-title>User Settings</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Use Button to Manual Filtering</strong></th>
          <td>
            {{profileModel.settings.useManualReportsFiltering ? 'Yes' : 'No'}}
          </td>
        </tr>
        <tr>
          <th><strong>Unsubscribe from push notifications</strong></th>
          <td>
            <button type="button" mat-raised-button color="primary" [promiseBtn]="buttonSubmitPromise"
                    (click)="onUnsubscribe()">Unsubscribe
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
    <mat-card-actions>
      <a routerLink="{{editProfileUrl}}" mat-raised-button color="primary" matTooltip="Edit Profile"
         *ngIf="hasEditAccess">Edit</a>
    </mat-card-actions>
  </mat-card>
</div>

<div class="main-container" *ngIf="hasDevices">
  <mat-card appearance="outlined">
    <mat-card-title>Devices</mat-card-title>
    <mat-card-content class="table-container">
      <mat-table [dataSource]="dataSource" class="regular-table responsive">
        <ng-container matColumnDef="appName">
          <mat-header-cell *matHeaderCellDef>App Name</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="mobile-label">App Name:</span>
            {{element.appName}} v{{element.appVersion}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="deviceModel">
          <mat-header-cell *matHeaderCellDef>Device</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="mobile-label">Device:</span>
            {{element.deviceModel}} - {{element.deviceOs}} {{element.deviceOsVersion}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="isPushEnabled">
          <mat-header-cell *matHeaderCellDef>Notifications</mat-header-cell>

          <mat-cell *matCellDef="let element">
            <span class="mobile-label">Notifications:</span>
            {{element.isPushEnabled | yesno}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="mobile-label">&nbsp;</span>
            <button mat-icon-button color="warn" matTooltip="Delete"
                    (click)="onDeleteDeviceConfirm($event, element)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </mat-card-content>
    <mat-card-actions>
      <a routerLink="{{editProfileUrl}}" mat-raised-button color="primary" matTooltip="Edit Profile"
         *ngIf="hasEditAccess">Edit</a>
    </mat-card-actions>
  </mat-card>
</div>
